import React, { useState } from "react";
import { useHistory } from "react-router-dom";

import Select from "react-select";

export const AddPickUp = () => {
	const history = useHistory();
	return (
		<div className="row">
			<div className="col-lg-12">
				<div className="card">
					<div className="card-body">
						<form className="control-form">
							<div className="row">
								<div className="mb-3 col-6">
									<label className="form-label">Customer Name</label>
									<input
										className="form-control"
										placeholder="Enter Customer Name "
									/>
								</div>
								<div className="mb-3 col-6">
									<label className="form-label">Mobile No.</label>
									<input
										className="form-control"
										placeholder="Enter Mobile No "
									/>
								</div>
							</div>
							<div className="row">
								<div className="mb-3 col-6">
									<label className="form-label">Retailer No.</label>
									<input
										className="form-control"
										placeholder="Enter Retailer No. "
									/>
								</div>
								<div className="mb-3 col-6">
									<label className="form-label">Job No.</label>
									<input
										className="form-control"
										placeholder="Enter Job No. "
									/>
								</div>
							</div>
							<div className="row">
								<div className="mb-3 col-6">
									<label className="form-label">Pick Up</label>
									<Select>
										<option>Select PickUps</option>
										<option>Retailer Delivery </option>
										<option>S2D Collection</option>
									</Select>
								</div>
								<div className="mb-3 col-6"></div>
							</div>
							<div className="row">
								<div className="mb-3 col-6">
									<label className="form-label">Transport Vendor Name</label>
									<input
										className="form-control"
										placeholder="Enter Transport Vendor Name"
									/>
								</div>

								<div className="mb-3 col-6">
									<label className="form-label">Location</label>
									<input
										className="form-control"
										placeholder="Enter Location "
									/>
								</div>
							</div>
							<div className="row">
								<div className="mb-3 col-6">
									<label className="form-label">Local Delivery Warehouse</label>
									<input
										className="form-control"
										placeholder="Enter Local Delivery Warehouse "
									/>
								</div>
								<div className="mb-3 col-6">
									<label className="form-label">Pick Up Date</label>
									<input
										type="date"
										className="form-control"
										placeholder="Enter >Pick Up Date"
									/>
								</div>
								<div className="mb-3 col-6">
									<label className="form-label">Comments</label>
									<textarea
										type="text"
										className="form-control"
										placeholder="Enter Comments "
									/>
								</div>
							</div>
							<div className="mt-3 d-flex justify-content-between">
								<button
									className="btn btn-danger w-sm waves-effect waves-light"
									type="button"
									onClick={() => history.goBack()}
								>
									Back
								</button>
								<button
									className="btn btn-primary w-sm waves-effect waves-light"
									type="button"
									onClick={() => console.log("fdgfdg")}
								>
									Submit
								</button>
							</div>
						</form>
					</div>
				</div>
			</div>
		</div>
	);
};
